import type { BidRow, AuctionChatItem } from "@/lib/auction-types"

export function toFiniteNumber(value: unknown): number | null {
  if (typeof value === "number") return Number.isFinite(value) ? value : null
  if (typeof value === "string" && value.trim().length > 0) {
    const parsed = Number(value)
    return Number.isFinite(parsed) ? parsed : null
  }
  return null
}

export function sortBids(rows: BidRow[]): BidRow[] {
  return [...rows].sort((a, b) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime())
}

export function normalizeBidRow(raw: unknown): BidRow | null {
  if (!raw || typeof raw !== "object") return null
  const row = raw as Record<string, unknown>
  if (typeof row.id !== "string" || row.id.length === 0) return null
  const amount = toFiniteNumber(row.amount)
  if (amount == null) return null
  const createdAt =
    typeof row.created_at === "string" && row.created_at.length > 0
      ? row.created_at
      : new Date().toISOString()
  const bidderDisplay =
    typeof row.bidder_display === "string" && row.bidder_display.length > 0
      ? row.bidder_display
      : "Bidder"
  return {
    id: row.id,
    bidder_id: typeof row.bidder_id === "string" ? row.bidder_id : undefined,
    amount,
    created_at: createdAt,
    bidder_display: bidderDisplay,
    avatar_url: typeof row.avatar_url === "string" ? row.avatar_url : null,
  }
}

export function normalizeChatItem(raw: unknown): AuctionChatItem | null {
  if (!raw || typeof raw !== "object") return null
  const item = raw as Record<string, unknown>
  if (typeof item.id !== "string" || item.id.length === 0) return null
  if (typeof item.created_at !== "string" || item.created_at.length === 0) return null
  const username =
    typeof item.username === "string" && item.username.length > 0 ? item.username : "?"
  const userId = typeof item.user_id === "string" ? item.user_id : ""
  const avatarUrl = typeof item.avatar_url === "string" ? item.avatar_url : null

  if (item.type === "bid") {
    const amount = toFiniteNumber(item.amount)
    if (amount == null) return null
    return {
      type: "bid",
      id: item.id,
      created_at: item.created_at,
      user_id: userId,
      username,
      avatar_url: avatarUrl,
      amount,
    }
  }

  const type = item.type === "hype" ? "hype" : "message"
  const body = typeof item.body === "string" ? item.body : ""
  return {
    type,
    id: item.id,
    created_at: item.created_at,
    user_id: userId,
    username,
    avatar_url: avatarUrl,
    body,
  }
}
